import "../../Styles/dashboard/overview.css"
import {GrMoney} from "react-icons/gr"
import {BsBoxSeam} from "react-icons/bs"
import {GiShoppingBag} from "react-icons/gi"
import {FaLayerGroup} from "react-icons/fa"
import React, { useEffect, useState } from "react"
import Loader from "react-js-loader";
import Chart from "react-apexcharts";
import Sidebar from "../../components/dashboard/sidebar"


const Dashboard = () => {

    const [fetch, setFetched] = useState(false)

    useEffect(() => {
        setFetched(true)
    }, [])

   
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug","Sep", "Oct", "Nov", "Dec"]
    const options = {
        xaxis: {
          categories: month
        },
        colors: ['rgb(9, 183, 9)']
      };
      const series = [
        {
          name: "Monthly Sales",
          data: [200, 300, 2031.5, 432.4, 1200, 120, 450, 32, 400, 300, 430, 123.4],
        },
      ];

    return<>
    
        <Sidebar/>

        {
            !fetch ?
            <div className="loader">
                <Loader type="box-rectangular" bgColor={"rgb(190,142,30)"} title={"box-rotate-x"} color={'green'} size={50} />
            </div> :
        
        <div className="dashboardWrapper">
            <div className="cardsWrapper">
                <div className="card">
                    <GrMoney/>
                    <p>Total Sales</p>
                    <h3>N5000</h3>
                </div>
                <div className="card">
                    <GiShoppingBag/>
                    <p>Total Order</p>
                    <h3>20</h3>
                </div>
                <div className="card" >
                    <FaLayerGroup/>
                    <p>Total Shops</p>
                    <h3>6</h3>
                </div>
                <div className="card">
                    <BsBoxSeam/>
                    <p>Total Product</p>
                    <h3>40</h3>
                </div>
            </div>

            <div className="DashboardBottomSection">
                <div className="leftBottomSection">
                    <div className="chartWrapper">
                        <h2>Monthly Sales for 2023</h2>
                        <Chart   options={options} series={series} type="area"   height={350} />
                        
                    </div>

                    
                </div>

                
            </div>
        </div>
        }
    </>

}

export default Dashboard